export enum Cookie {
    'ConsentGiven' = 'ConsentGiven',
    'ProvisionedUser' = 'ProvisionedUser',
}
